module.exports = __webpack_public_path__ + "img/Courses.8aa64a2f.png";